import Vue from 'vue';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content') ?? '';

async function postJson(url, data) {
    const res = await fetch(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': csrfToken,
            'X-Requested-With': 'XMLHttpRequest',
        },
        credentials: 'same-origin',
        body: JSON.stringify(data),
    });
    if (!res.ok) {
        const err = new Error(`HTTP ${res.status}`);
        err.status = res.status;
        try { err.responseJSON = await res.json(); } catch {}
        throw err;
    }
    return res;
}

// Partnerfinder Vue-app
window.vueAppPartnerfinder = new Vue({
    el: '#at-partner-stage',
    data: {
        partnerSearchUrl: '',
        registerWithNicatSearchUrl: '',
        domain: false,
        features: [],
        search: null,
        showDomainSearchResult: false,
        isFetching: false,
        fetchPending: false,
        fetchError: false,
        partners: [],
        partnerCount: 0,
        activePage: 1
    },
    computed: {
        pageCount: function () {
            return Math.ceil(this.partnerCount / this.partnersPerPage);
        },
        offset: function () {
            return (this.activePage * this.partnersPerPage) - this.partnersPerPage;
        },
        partnersPerPage: function() {
            let screenWidth = (window.innerWidth > 0) ? window.innerWidth : screen.width;
            if (screenWidth > 500 && screenWidth < 990) {
                return 9;
            }
            return 8;
        }
    },
    methods: {
        selectDomain: function (event) {
            this.domain = {
                'domain_label': event.target.getAttribute('data-domain-label'),
                'domain_pdo': event.target.getAttribute('data-domain-pdo')
            }
            this.showDomainSearchResult = false;
        },
        fetchPartners: function () {
            if (this.isFetching === false) {
                this.isFetching = true;
                this.fetchError = false;
                this.successMessage = "";
                postJson(this.partnerSearchUrl, {
                    domain: this.domain,
                    features: this.features,
                    search: this.search,
                    offset: this.offset,
                }).then(res => res.json()).then(data => {
                    this.isFetching = false;
                    this.partners = this.fixPartnersArray(data.partners);
                    this.partnerCount = data.partner_count;
                    if (this.fetchPending) {
                        this.fetchPending = false;
                        this.fetchPartners();
                    }
                }).catch(() => {
                    this.fetchError = true;
                    this.isFetching = false;
                });
            }
            else {
                this.fetchPending = true;
            }
        },
        fixPartnersArray(partners) {
            if (!Array.isArray(partners)) {
                return partners;
            }
            for (let i = 0; i < partners.length; i++) {
                let partner = partners[i];
                if (!Array.isArray(partner.features)) {
                    partner.features = JSON.parse(partner.features);
                }
            }
            return partners;
        },
        getRegisterUrl: function (partner) {
            if (this.domain != false && partner.url_domain !== null && partner.url_domain.length > 0) {
                return partner.url_domain
                    .replace('%domain%', this.domain.domain_label)
                    .replace('%tld%', this.domain.domain_pdo);
            }
            return partner.url;
        },
        getFullDomain: function() {
            if (this.domain != false) {
                return this.domain.domain_label + '.' + this.domain.domain_pdo;
            }
            return false;
        },
        addDomainToNicAtCart: function(event) {
            if (this.domain != false) {
                event.preventDefault();
                postJson('/cart/add', { domain: this.getFullDomain() });
            }
        },
        registerWithNicat: function(event) {
            event.preventDefault();
            
            if (this.domain === false) {
                window.location.href = this.registerWithNicatSearchUrlGet;
                return;
            }
            
            let redirectUri = this.registerWithNicatSearchUrl;
    
            postJson('/cart/add', { domain: this.getFullDomain() })
                .then(function() {
                    let searchForm = document.getElementById('search-form');
                    searchForm.action = redirectUri;
                    searchForm.submit();
                })
                .catch(function(err) {
                    if (err.status === 422 && err.responseJSON?.redirect) {
                        window.location.href = err.responseJSON.redirect;
                    }
                });
        },
        previousPage: function(event) {
            event.preventDefault();
            if (this.activePage != 1) {
                this.activePage -= 1;
            }
        },
        nextPage: function(event) {
            event.preventDefault();
            if (this.activePage < this.pageCount) {
                this.activePage += 1;
            }
        },
        fireMatomoEvent: function(action, name, value) {
            _paq.push(['trackEvent', 'Partnerfinder', action, name]);
        },
        partnerHasAtLeastOneOfTheseFeatures: function(partner, features) {
            let partnerHasAtLeastOneOfTheseFeatures = false;
            features.forEach(function(feature) {
                if (partner.features.indexOf(feature) >= 0) {
                    partnerHasAtLeastOneOfTheseFeatures = true;
                }
            });
            return partnerHasAtLeastOneOfTheseFeatures;
        }
    },
    watch: {
        showDomainSearch: function (show) {
            let collapse = 'show'
            if (show === false) {
                collapse = 'hide';
            }
            $('#domain-search-form').collapse(collapse);
            if (show === true) {
                $('#domain-search-form').find('input[name="domain_name[domain_label]"]').focus()
            }
        },
        features: function (features) {
            this.activePage = 1;
            this.fetchPartners();
        },
        search: function (search) {
            this.activePage = 1;
            this.fetchPartners();
        },
        activePage: function (activePage) {
            this.fetchPartners();
        },
        isFetching: function (isFetching) {
            if (isFetching) {
                $('.form-submit-curtain').show();
            }
            else {
                $('.form-submit-curtain').hide();
            }
        },
        partnerCount: function (newCount, oldCount) {
            if (newCount === 0 && (oldCount > 0)) {
                this.fireMatomoEvent('Keine Treffer');
            }
        },
        partners: function () {
            if (this.partners.length > this.partnersPerPage) {
                this.partners.pop();
            }
        }
    }
});